import { QuiereRenovar } from "../../../types/renewals";

const OPTIONS: { value: QuiereRenovar; label: string; color: string }[] = [
  { value: "yes", label: "Sí", color: "#1a7f37" },
  { value: "maybe", label: "Quizás", color: "#856404" },
  { value: "no", label: "No", color: "#b32424" },
  { value: "no_response", label: "Sin respuesta", color: "#73879C" },
];

type Props = {
  value: QuiereRenovar | null;
  disabled?: boolean;
  onChange: (next: QuiereRenovar | null) => void;
};

export default function QuiereRenovarSelect({ value, disabled, onChange }: Props) {
  const current = OPTIONS.find((o) => o.value === value);
  return (
    <select
      value={value ?? ""}
      disabled={disabled}
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => {
        const v = e.target.value;
        onChange(v === "" ? null : (v as QuiereRenovar));
      }}
      style={{
        padding: "0.2rem 0.4rem",
        borderRadius: "0.35rem",
        border: "1px solid #dee2e6",
        background: "white",
        fontSize: "0.75rem",
        fontWeight: 600,
        color: current?.color ?? "#73879C",
        cursor: disabled ? "wait" : "pointer",
        minWidth: "5rem",
      }}
    >
      <option value="">—</option>
      {OPTIONS.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  );
}
